import React from 'react'
import NavigationContainer from './nav'

const Header = () => {
  return (
    <NavigationContainer/>
  )
}

export default Header